export const runway = /^(?<QFU>\d{2})(?<variant>(C|L|R)?)$/u;
